import { createApi } from '@reduxjs/toolkit/dist/query/react';
import baseQueryWithReauth from 'client/util/baseQueryWithReauth';

export const mcpOAuthSlice = createApi({
  reducerPath: 'mcpOAuthReducer',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['mcpConnection'],
  endpoints: builder => ({
    getConsentInfo: builder.query({
      query: authorizationId => `/mcp-oauth/consent-info?authorization_id=${authorizationId}`,
    }),
    approveConsent: builder.mutation({
      query: body => ({
        url: '/mcp-oauth/consent/approve',
        method: 'POST',
        body,
      }),
    }),
    denyConsent: builder.mutation({
      query: body => ({
        url: '/mcp-oauth/consent/deny',
        method: 'POST',
        body,
      }),
    }),
    listConnections: builder.query({
      query: () => '/mcp-oauth/connections',
      providesTags: [{ type: 'mcpConnection', id: 'LIST' }],
    }),
    revokeConnection: builder.mutation({
      query: id => ({
        url: `/mcp-oauth/connections/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'mcpConnection', id: 'LIST' }],
    }),
    listAccessLog: builder.query({
      query: ({ page = 1, perPage = 20, orgId } = {}) => {
        const params = new URLSearchParams({ page: String(page), per_page: String(perPage) });
        if (orgId) {
          params.set('org_id', orgId);
        }
        return `/mcp-oauth/access-log?${params.toString()}`;
      },
    }),
  }),
});

export const {
  useGetConsentInfoQuery,
  useApproveConsentMutation,
  useDenyConsentMutation,
  useListConnectionsQuery,
  useRevokeConnectionMutation,
  useListAccessLogQuery,
  reducer: mcpOAuthReducer,
} = mcpOAuthSlice;

export default mcpOAuthSlice;
